import * as ActionType from "./language.type";

const initialState = {
  languages: [],
  translations: null,
  languageOptions: [],
  totalLanguages: 0,
  isLoading: true,
};

export const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_ALL_LANGUAGES:
      return {
        ...state,
        languages: action.payload.data,
        totalLanguages: action.payload.total,
        isLoading: false,
      };

    case ActionType.CREATE_LANGUAGE:
      return {
        ...state,
        languages: [action.payload, ...state.languages],
        isLoading: false,
      };

    case ActionType.UPDATE_LANGUAGE:
      return {
        ...state,
        languages: state.languages.map((lang) =>
          lang._id === action.payload._id ? action.payload : lang
        ),
        isLoading: false,
      };

    case ActionType.TOGGLE_LANGUAGE:
      const { languageCode, toggleType, isActive } = action.payload;
      return {
        ...state,
        languages: state.languages.map((lang) => {
          if (lang.languageCode === languageCode) {
            if (toggleType === 1) {
              return { ...lang, isActive: isActive };
            } else if (toggleType === 2) {
              return { ...lang, isDefault: true };
            }
          } else if (toggleType === 2) {
            return { ...lang, isDefault: false };
          }
          return lang;
        }),
        isLoading: false,
      };

    case ActionType.DELETE_LANGUAGE:
      return {
        ...state,
        languages: state.languages.filter(
          (lang) => lang.languageCode !== action.payload
        ),
        isLoading: false,
      };

    case ActionType.GET_LANGUAGE_TRANSLATIONS:
      return {
        ...state,
        translations: action.payload?.doc || null,
        isLoading: action.payload?.loading ?? false,
      };

    case ActionType.GET_LANGUAGE_OPTIONS:
      return {
        ...state,
        languageOptions: action.payload,
      };

    default:
      return state;
  }
};
